import { getPageConfig } from '@/lib/aggregation';
import type { Experiment } from '@/types/aggregation/home';

export const getExperiments = async ({ currentRoute }: { currentRoute: string }): Promise<Experiment> => {
    const response = await getPageConfig(currentRoute);

    return response?.experiments || {};
};
